<template>
  <div>
    <h1 class="text-center">{{ schema.$title }}</h1>

    <panel :title="schema.data.applicant.$title">
      <w-radio-list class="form-group" :model="schema.data.creatorType" :values="dictionary.creatorTypes" />

      <person-with-pesel :model="schema.data.applicant">
        <div class="row form-group">
          <div class="col-6">
            <w-input :model="schema.data.applicant.phoneNumber" />
          </div>
        </div>
      </person-with-pesel>
    </panel>

    <panel :title="schema.data.tenderer.$title">
      <person-with-pesel
        :model="schema.data.tenderer"
        :has-address="false"
        :disabled="{
          firstName: schema.data.creatorType.$model === 1,
          lastName: schema.data.creatorType.$model === 1,
          pesel: schema.data.creatorType.$model === 1,
          birthDate: schema.data.creatorType.$model === 1 || hasPesel
        }"
      >
        <div>
          <w-radio-list :model="schema.data.tenderer.studentType" :values="dictionary.studentTypes" />
        </div>
      </person-with-pesel>
    </panel>

    <panel :title="schema.data.school.$title">
      <school-picker-duplikaty :school-model="schema.data.school" :with-parents="true" />
    </panel>

    <panel :title="schema.data.details.$title">
      <w-radio-list class="form-group" :model="schema.data.details.documentType" :values="dictionary.documentTypes" />

      <w-input class="form-group" :model="schema.data.details.class" />

      <w-radio-list
        class="form-group"
        :model="schema.data.details.deliveryMethod"
        :values="dictionary.deliveryMethods"
      />
    </panel>

    <panel v-if="!schema.data.details.receiver.$disabled" :title="schema.data.details.receiver.$title">
      <div class="row form-group">
        <w-input class="col-md-6" :model="schema.data.details.receiver.firstName" />

        <w-input class="col-md-6" :model="schema.data.details.receiver.lastName" />

        <w-input class="col-md-6" :model="schema.data.details.receiver.phoneNumber" />
      </div>
    </panel>

    <panel :title="schema.data.paymentInformation.$title">
      <div v-html="schema.data.paymentInformation.$model" />
    </panel>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Panel from '@/components/panel/Panel.vue';
import { documentFormMixin } from '@/mixins/document/documentForm';
import PersonWithPesel from '../PersonWithPesel.vue';
import SchoolPickerDuplikaty from '../SchoolPickerDuplikaty.vue';

// @vuese
// Formularz wniosku o wydanie duplikatu
export default {
  components: { ...components, Panel, PersonWithPesel, SchoolPickerDuplikaty },
  mixins: [documentFormMixin],
  props: {
    // schema dokumentu
    schema: { type: Object, required: true }
  },

  computed: {
    hasPesel() {
      return this.schema.data.tenderer.pesel.$model?.length === 11;
    }
  }
};
</script>
